import React, { useEffect, useState } from "react";
import { Card, Typography, Button, Dropdown, Menu, Space } from "antd";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

import { CalendarOutlined } from "@ant-design/icons";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { getFrequencyOfPainTriggersWithRating } from "../redux-toolkit/slices/dashboardSlice";
import { useSelector } from "react-redux";
import DashboardDateFilter from "./DashboardDateFilter";

const { Title } = Typography;

const DashboardPainTriggersChart = () => {
  const [filter, setFilter] = useState<string>("7");

  const dispatch = useAppDispatch();
  const { isError, isPainFrequencyReportLoading, painFrequencyReportData } =
    useSelector((state: RootState) => state.dashboard);
  useEffect(() => {
    dispatch(getFrequencyOfPainTriggersWithRating(filter));
  }, []);
  const onFilterChange = (filter: string) => {
    setFilter(filter);
    dispatch(getFrequencyOfPainTriggersWithRating(filter));
  };
  const chartOptions: ApexOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    colors: ["#2B6CB0", "#333333"], // Bar chart in dark blue, line chart in dark gray
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        // endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      curve: "smooth",
      colors: ["#333333"], // Line color for Relief methods
    },
    xaxis: {
      categories: painFrequencyReportData.map((item) => item.trigger),
      labels: {
        offsetY: -8,
        rotateAlways: true,
        rotate: -30,
        style: {
          colors: "#333333", // Match text color to screenshot
          fontSize: "10px",
        },
      },
    },
    yaxis: [
      {
        title: {
          text: "Frequency",
          style: {
            color: "#333333",
          },
        },
        min: 0,
        // max: 50,
        labels: {
          style: {
            colors: "#333333",
          },
        },
      },
      {
        opposite: true,
        title: {
          text: "Relief methods",
          style: {
            color: "#333333",
          },
        },
        min: 0,
        max: 5,
        tickAmount: 5, // Ensure increments of 1
        labels: {
          style: {
            colors: "#333333",
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      markers: {
        // radius: 12,
      },
      labels: {
        colors: "#333333",
      },
    },
    grid: {
      borderColor: "#e7e7e7",
    },
  };

  const chartSeries = [
    {
      name: "Frequency",
      type: "bar",
      data: painFrequencyReportData.map((item) => item.frequency), // [30, 35, 30, 25, 35, 45, 25, 30, 20, 25],
    },
    {
      name: "Relief methods",
      type: "line",
      data: painFrequencyReportData.map((item) => item.averageRating), // [3, 4, 3, 2, 4, 5, 2, 3, 2, 3],
    },
  ];

  return (
    <Card>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Title level={3}>Frequency of Pain Triggers</Title>
        <DashboardDateFilter value={filter} onChange={onFilterChange} />
      </div>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </Card>
  );
};

export default DashboardPainTriggersChart;
